import { StyleSheet, Text, View } from "react-native";
import { CONTROL_HEIGHT, RADIUS, colors } from "../native/colors";

/**
 * The vendor checkout's rows before the buyer's profile is read, at the
 * heights they will have: the destination, the details and the card's
 * three fields. Native and app-web draw it alike.
 */
export function VendorShape({
  destination,
}: {
  /** What the address is for (`goodsWords`): tickets go to it;
   *  merch is posted and only its emails do. */
  destination: string;
}) {
  return (
    <View
      accessibilityLabel="Loading checkout"
      aria-busy
      testID="vendor-checkout-shape"
    >
      <View style={[styles.row, styles.gap16]}>
        <Text style={styles.label}>{destination}</Text>
        <View style={styles.pill} />
      </View>
      <View style={[styles.details, styles.gap16]}>
        <Text style={styles.label}>Your details</Text>
        <View style={styles.summary} />
      </View>
      <View style={[styles.fields, styles.gap12]}>
        <View style={styles.field} />
        <View style={styles.fieldRow}>
          <View style={styles.field} />
          <View style={styles.field} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  gap12: { paddingBottom: 12 },
  gap16: { paddingBottom: 16 },
  row: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  label: { color: colors.text, fontSize: 13, fontWeight: "600" },
  pill: {
    backgroundColor: colors.fill,
    borderRadius: 999,
    height: 26,
    width: 170,
  },
  details: { gap: 8 },
  summary: {
    borderColor: colors.border,
    borderRadius: RADIUS,
    borderWidth: 1,
    height: 74,
  },
  fields: { gap: 8 },
  fieldRow: { flexDirection: "row", gap: 8 },
  field: {
    borderColor: colors.border,
    borderRadius: RADIUS,
    borderWidth: 1,
    flex: 1,
    height: CONTROL_HEIGHT,
  },
});
